import { useEffect, useState } from "react";
import { bankDetails, countries, funds } from "../../api/fundsCalculatorApi";

export const Step3Form = ({ formData, handleInputChange }) => {
  const [country, setCountry] = useState([]);
  const [fundType, setFundType] = useState([]);
  const [bankName, setBankName] = useState([]);

  const fetchFunds = async () => {
    try {
      const response = await funds();
      setFundType(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await countries();
      setCountry(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBankDetails = async (countryId) => {
    try {
      setBankName([]);

      const response = await bankDetails({ country_id: countryId });

      const banks = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      const formattedBanks = banks.map((b) => ({
        ...b,
        id: b.id.toString(),
      }));

      setBankName(formattedBanks);
    } catch (err) {
      console.error("Error fetching bank details:", err);
      setBankName([]);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchFunds();
  }, []);

  useEffect(() => {
    if (formData.financialInstitutionCountry) {
      fetchBankDetails(formData.financialInstitutionCountry);
    } else {
      setBankName([]);
    }
  }, [formData.financialInstitutionCountry]);

  useEffect(() => {
    if (bankName.length > 0 && formData.financialInstitutionName) {
      const found = bankName.find(
        (b) => b.id.toString() === formData.financialInstitutionName.toString(),
      );
      if (!found) {
        handleInputChange("financialInstitutionName", "");
      }
    }
  }, [bankName]);

  return (
    <div className="grid grid-cols-3 gap-6 mb-6">
      {/* Select Sponsor Name */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Select Sponsor Name <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.SelectSponsorName || ""}
          onChange={(e) =>
            handleInputChange("SelectSponsorName", e.target.value)
          }
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option value="" disabled>
            -- Select Sponsor --
          </option>
          {formData.sponsors.map((s, index) => (
            <option key={index} value={s.sponsorName}>
              {s.sponsorName}
            </option>
          ))}
        </select>
      </div>

      {/* Sponsor's Amount */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Sponsor's Amount <span className="text-red-500">*</span>
        </label>
        <input
          placeholder="Enter Sponsor Amount"
          type="number"
          value={formData.sponsorsAmount || ""}
          onChange={(e) => handleInputChange("sponsorsAmount", e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        />
      </div>

      {/* Financial Institution's Country */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Financial Institution's Country{" "}
          <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.financialInstitutionCountry?.toString() || ""}
          onChange={(e) =>
            handleInputChange("financialInstitutionCountry", e.target.value)
          }
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option value="">Select Country</option>
          {Array.isArray(country) &&
            country.map((item) => (
              <option key={item.id} value={item.id.toString()}>
                {item.country_name}
              </option>
            ))}
        </select>
      </div>

      {/* Financial Institution's Name */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Financial Institution's Name <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.financialInstitutionName?.toString() || ""}
          onChange={(e) =>
            handleInputChange("financialInstitutionName", e.target.value)
          }
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
          disabled={!formData.financialInstitutionCountry}
        >
          <option value="">
            {!formData.financialInstitutionCountry
              ? "Select a country first"
              : bankName.length === 0
                ? "No banks available"
                : "Select Bank"}
          </option>

          {bankName.map((item) => (
            <option key={item.id} value={item.id}>
              {item.bank_name}
            </option>
          ))}
        </select>
      </div>

      {/* Type of Funds */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Type of Funds <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.typeOfFunds}
          onChange={(e) => handleInputChange("typeOfFunds", e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option value="">Select type of fund</option>
          {fundType.map((item) => (
            <option key={item.id} value={item.id}>
              {item.document_name}
            </option>
          ))}
        </select>
      </div>

      {/* Proof of Funds (optional) */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Proof of Funds{" "}
          <span className="text-gray-500 text-sm">(optional)</span>
        </label>
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => {
            const file = e.target.files?.[0];

            if (file) {
              if (file.type !== "application/pdf") {
                alert("Only PDF files are allowed.");
                e.target.value = "";
                return;
              }

              const maxSizeInBytes = 5 * 1024 * 1024;
              if (file.size > maxSizeInBytes) {
                alert("File size must be less than 5 MB.");
                e.target.value = "";
                return;
              }

              handleInputChange("proofOfFunds", file);
            } else {
              handleInputChange("proofOfFunds", null);
            }
          }}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        />
      </div>

      {/* 6 Months Old Funds */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-4">
          6 Months Old Funds? <span className="text-red-500">*</span>
        </label>

        <div className="flex space-x-6">
          {/* Yes Option */}
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="oldFunds"
              value={1}
              checked={formData.oldFunds === 1}
              onChange={(e) =>
                handleInputChange("oldFunds", Number(e.target.value))
              }
              className="w-4 h-4 border-[#9b228e] accent-[#9b228e] focus:ring-0"
            />
            <span className="ml-2 text-black text-[16px]">Yes</span>
          </label>

          {/* No Option */}
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="oldFunds"
              value={0}
              checked={formData.oldFunds === 0}
              onChange={(e) =>
                handleInputChange("oldFunds", Number(e.target.value))
              }
              className="w-4 h-4 border-gray-400 accent-[#9b228e] focus:ring-0"
            />
            <span className="ml-2 text-black text-[16px]">No</span>
          </label>
        </div>
      </div>
    </div>
  );
};
